import PermissionCheck from '@/tools/permission-check';

export default {
	install(Vue, options) {
		Vue.prototype.can = PermissionCheck.can
		Vue.prototype.is = PermissionCheck.is
	}
}